import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import HeroHeader from '@/vdp/HeroHeader/HeroHeader';
import { useScreenSize } from '~/context/common/DeviceContext';
import { getVehicleDetails } from '~/selectors';
import {
  Container,
  ImageDisclaimer,
  Vehicle,
  Wrapper
} from './OnDemandHero.styles';

function useImageUrl(): string {
  const {
    stockImageData: { jellyBeanMobileUrl = '', jellyBeanDesktopUrl = '' } = {}
  } = useSelector(getVehicleDetails);
  const { width } = useScreenSize();

  return width < legacyBreakpoints.m ? jellyBeanMobileUrl : jellyBeanDesktopUrl;
}

const OnDemandHero = () => {
  const {
    make,
    model,
    stockImageData: { isGenericJellyBean } = {}
  } = useSelector(getVehicleDetails);
  const imageUrl = useImageUrl();

  return (
    <Wrapper>
      <HeroHeader />
      <Container>
        <Vehicle src={imageUrl} alt="A vehicle" />
        <ImageDisclaimer>
          <p className="tl-body-s">© Carvana, LLC</p>
          {isGenericJellyBean ? (
            <p className="tl-header-xs">Photos of the vehicle coming soon!</p>
          ) : (
            <p className="tl-header-xs">
              This is a stock image of a {make} {model}.<br /> Photos of the
              actual vehicle coming soon!
            </p>
          )}
        </ImageDisclaimer>
      </Container>
    </Wrapper>
  );
};

export default memo(OnDemandHero);
